import './bootstrap';
import {document} from "postcss";

require('isotope-layout/dist/isotope.pkgd.min.js');

$(document).ready(function(){
    //start: confirmation required modal handling
    const confirmationModal = $('#confirmationModal');
    if(confirmationModal.length > 0){
        confirmationModal.show();
        $('#body').css('overflow-y', 'hidden');
        $('#pageContent').css('filter', 'blur(8px)');
    }
    $("#confirmButtonConfirmationModal").click(function(e){
        confirmationModal.hide();
        $('#body').css('overflow-y', 'unset');
        $('#pageContent').css('filter', 'none');
    });

    $("#confirmation-required-modal-checkbox").click(function(){
        $("#confirmButtonConfirmationModal").toggleClass("disabled");
    });
    //end: confirmation required modal handling

    $(".hamburger").click(function(){
        $(".hamburger").toggleClass("is-active");
        $('.nav-links').toggleClass("show");
        $('body').toggleClass("menu-open");
        $('.mainnav').toggleClass("menu-open");
        $('.lupus-finder-wrapper').toggleClass("show");
    });

    $(".toggle-mobile-dropdown").click(function() {
        $(this).parent().next(".nav-dropdown").slideToggle();
        $(this).toggleClass('toggled');
    });

    const $navbar = $('#mainnav');

    $(".sliding-link-offset").click(function(e) {
        e.preventDefault();
        var aid = $(this).attr("href");

        var element = document.getElementById(aid.replace("#", ""));
        var headerOffset = $navbar.outerHeight() + 25;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    });

    require('../externalLinksPopup.js');

    if(getUrlParameter('showBanner') === 'true') {
        setCookie('show_banner', 'true', 1);
    }

    if(getCookie('show_banner')==='true'){
        document.getElementById('banner').classList.add("show");
        document.getElementById('banner-bottom').classList.add("show");
        document.getElementById('mainnav').classList.add("has-banner");
        document.getElementById('nav-links').classList.add("has-banner");
        document.getElementById('pageContent').classList.add("has-banner");
    }
});

//works with single and multiple parameters
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$(".on-click-display-element").click(function(e){
    e.target.classList.add('d-none');
    document.getElementById(e.target.getAttribute('data-bs-target')).classList.remove('d-none');
});


